<app-header-content-footer *transloco="let t">
  <app-sidenav-content content>
    <router-outlet content></router-outlet>
  </app-sidenav-content>
</app-header-content-footer>
